import { Middleware } from "redux";

import {
  pushDataLayer,
  getPageLoadModelNO,
  getServerErrorModelNO,
  getDataUpdateModelNO,
  getEcommerceModelNO,
  getLocalValidationErrorModelNO,
} from ".";
import { CHECKOUT_ROUTE, DONE_ROUTE } from "../store/nissan_no";

import {
  RECEIVE_INITIAL,
  COMPLETED,
  PROCESSING_END,
  SET_SERVER_ERROR,
  RECEIVE_PRICE,
  RECEIVE_QUOTE,
  SET_FIELD_VALIDATION_ERROR,
} from "../store/actions";

import { FOOTER_COVERAGE_CHANGED } from "../store/Footer";
import { INSURANCE_RECEIVE_TYPE_CHANGED } from "../store/Insurance";
import { LOCATION_CHANGE, getLocation } from "connected-react-router";
import { isFunction } from "../helperFunctions";
import { DISTANCE_CHANGED } from "../store/Distance";

const actionHistory: any[] = [];
const sequencedActions: string[] = [RECEIVE_INITIAL, SET_SERVER_ERROR, RECEIVE_QUOTE, RECEIVE_PRICE, COMPLETED];

export const datalayerMiddlewareNo: Middleware = api => next => action => {
  const previousActionType = actionHistory.length > 0 ? actionHistory[actionHistory.length - 1] : undefined;
  const currentActionType = action.type;

  if (sequencedActions.includes(currentActionType)) {
    actionHistory.push(currentActionType);
  }

  // Call the next dispatch method in the middleware chain.
  const returnValue = next(action);

  // Capture new store state - state after dispatch
  const newState = api.getState();

  // make sure to wait for action to end.
  // Previous actions (e.g. RECEIVE_INITIAL) might end into error (e.g. SET_SERVER_ERROR) and we need to push error instead of successful event
  if (currentActionType === PROCESSING_END) {
    // handle events where server response is involved
    // push correct dataLayer event based on current action
    switch (previousActionType) {
      case RECEIVE_QUOTE:
        pushDataLayer(getPageLoadModelNO(newState, "Page Load", "price"));
        const bravi = (window as any).Bravi;
        if (bravi && bravi.gtm && isFunction(bravi.gtm)) {
          bravi.gtm();
        }
        break;
      case SET_SERVER_ERROR:
        pushDataLayer(getServerErrorModelNO(newState));
        break;
      case RECEIVE_PRICE:
        pushDataLayer(getDataUpdateModelNO(newState));
        break;
      case COMPLETED:
        pushDataLayer(getEcommerceModelNO(newState, "Purchase"));
        break;
    }
  } else if (currentActionType === LOCATION_CHANGE && !action.payload.isFirstRendering) {
    // handle navigatione;
    switch (getLocation(newState).pathname) {
      case CHECKOUT_ROUTE:
        pushDataLayer(getPageLoadModelNO(newState, "Virtual Page Load", "checkout"));
        pushDataLayer(getEcommerceModelNO(newState, "Checkout Step"));
        break;
      case DONE_ROUTE:
        pushDataLayer(getPageLoadModelNO(newState, "Virtual Page Load", "purchase"));
        break;
    }
  } else {
    // handle any other cases - action is performed, but without server or page load
    switch (currentActionType) {
      case DISTANCE_CHANGED:
      case FOOTER_COVERAGE_CHANGED:
      case INSURANCE_RECEIVE_TYPE_CHANGED:
        pushDataLayer(getDataUpdateModelNO(newState));
        break;
      case SET_FIELD_VALIDATION_ERROR:
        pushDataLayer(getLocalValidationErrorModelNO(newState, action.payload));
        break;
    }
  }

  return returnValue;
};
